import type { SxProps, Theme } from '@mui/material';
import type { PhoneMode } from './phone-input/index.ts';

export const baseFieldSx = (theme: Theme, sx?: SxProps<Theme>): SxProps<Theme> => ({
  '& .MuiOutlinedInput-root': {
    border: `4px solid ${theme.palette.accent}`,
    borderRadius: 10,
    backgroundColor: 'bisque',
    backdropFilter: 'blur(8px)',
    p: 0,
  },

  '& .MuiOutlinedInput-notchedOutline': {
    borderWidth: 2,
  },

  '& .MuiInputAdornment-root': {
    '& .MuiTypography-root': {
      ...theme.typography.title,
    },
    px: 10,
    py: 20,
    m: 0,
  },

  '& input': {
    ...theme.typography.button,
    color:theme.palette.dark,
    px: 8,
    py: 20,
  },

  '& input::placeholder': {
    color: theme.palette.lightDark,
    opacity: 1,
  },
  ...sx,
});

export const phoneOnlySx = (mode: PhoneMode) => ({
  '& .MuiTelInput-Flag': {
    borderRadius: 8,
  },

  ...(mode === 'callingCode'
    ? {
      '& .MuiInputAdornment-positionStart *': {
        visibility: 'hidden',
      },
    }
    : null),
});

export const overlaySx = (theme: Theme) => ({
  position: 'absolute',
  pointerEvents: 'none',
  whiteSpace: 'nowrap',
  ...theme.typography.title,
  color: theme.palette.lightDark,
  visibility: 'hidden',
});